import assert from 'assert'

export const assertCtxNotType = (ctx: any, prop: string, type: string) => {
    assert(typeof ctx[prop] !== type, `${ctx}.${prop} must not be of type ${type}`)
}

export const assertCtxIsType = (ctx: any, prop: string, type: string) => {
    assert(typeof ctx[prop] === type, `${ctx}.${prop} must be of type ${type}`)
}
